// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as BasicTypes$Showside from "../../types/BasicTypes.bs.js";
import * as NavMenu__Link$Showside from "./NavMenu__Link.bs.js";
import * as SectionContent$Showside from "../SectionContent.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as NavMenu__PLPContent$Showside from "./NavMenu__PLPContent.bs.js";
import * as NavMenu__Breadcrumbs$Showside from "./NavMenu__Breadcrumbs.bs.js";
function getAnyLayoutAsGrid(minColumns, category) {
  var columns = BasicTypes$Showside.GridColumns.minColumns(Category$Showside.Layout.getColumns(category.userSelectedLayout), Belt_Option.getWithDefault(minColumns, /* OneColumnGrid */0));
  var gap = Category$Showside.Layout.getGap(category.userSelectedLayout);
  var maxWidth = Category$Showside.Layout.getMaxWidth(category.userSelectedLayout);
  var padding = Category$Showside.Layout.getPadding(category.userSelectedLayout);
  var maxRows = Category$Showside.Layout.getMaxRows(category.userSelectedLayout);
  return {
    columns: columns,
    gap: gap,
    maxRows: maxRows,
    maxWidth: maxWidth,
    padding: padding,
    pattern: undefined
  };
}
function NavMenu__Sections$CLPSection(Props) {
  var index = Props.index;
  var category = Props.category;
  var limitMaxRowsOpt = Props.limitMaxRows;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var getForcedOpenLink = Props.getForcedOpenLink;
  var limitMaxRows = limitMaxRowsOpt !== undefined ? limitMaxRowsOpt : true;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var isSocialNetworkContent = Belt_Option.isSome(category.socialNetworkSource);
  var category$1 = React.useMemo(function () {
    return Category$Showside.setTabbedSubCategories(category, undefined);
  }, [category.lastModifiedAt]);
  var baseLayout = getAnyLayoutAsGrid(undefined, category$1);
  var layout = React.useMemo(function () {
    return {
      TAG: /* GridLayout */1,
      _0: {
        columns: baseLayout.columns,
        gap: baseLayout.gap,
        maxRows: limitMaxRows ? Belt_Option.orElse(Belt_Option.keep(baseLayout.maxRows, function (maxRows) {
          return maxRows > 1;
        }), isSocialNetworkContent ? undefined : ctx.mode === /* Hamburger */1 ? 2 : 1) : baseLayout.maxRows,
        maxWidth: baseLayout.maxWidth,
        padding: baseLayout.padding,
        pattern: baseLayout.pattern
      }
    };
  }, [category$1.lastModifiedAt]);
  var link = NavMenu__Link$Showside.useLinkFromCategory(undefined, category$1);
  var match = category$1.userSelectedLayout;
  var tmp;
  var exit = 0;
  if (typeof match === "number") {
    tmp = /* Category */1;
  } else {
    switch (match.TAG | 0) {
      case /* ProductGrid */3:
      case /* ProductSlider */4:
        exit = 1;
        break;
      default:
        tmp = /* Category */1;
    }
  }
  if (exit === 1) {
    var match$1 = Category$Showside.ExternalConnection.getConnection(category$1);
    if (match$1 !== undefined && typeof match$1 === "number") {
      switch (match$1) {
        case /* History */0:
          tmp = /* History */3;
          break;
        case /* Favorites */1:
          tmp = /* Favorites */2;
          break;
        case /* StoreCart */2:
          tmp = /* StoreCart */4;
          break;
      }
    } else {
      tmp = /* Products */0;
    }
  }
  var tmp$1;
  if (category$1.showTitle) {
    var tmp$2 = {
      path: [category$1],
      layout: layout
    };
    if (link !== undefined) {
      tmp$2.link = Caml_option.valFromOption(link);
    }
    tmp$1 = React.createElement(NavMenu__Breadcrumbs$Showside.make, tmp$2);
  } else {
    tmp$1 = null;
  }
  return React.createElement(SectionContent$Showside.make, {
    index: index,
    preferredContentType: tmp,
    shouldShowHeader: !isSocialNetworkContent,
    category: category$1,
    layout: layout,
    scrollableContainerRef: scrollableContainerRef,
    forcedOpenLink: getForcedOpenLink,
    enableInlineMedia: false,
    customTitle: tmp$1
  });
}
NavMenu__Sections$CLPSection.displayName = "NavMenu__Sections.CLPSection";
var make = React.memo(NavMenu__Sections$CLPSection);
var CLPSection = {
  make: make
};
function NavMenu__Sections$CLPQuickCategoriesSection(Props) {
  var category = Props.category;
  var path = Props.path;
  var link = Props.link;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var getForcedOpenLink = Props.getForcedOpenLink;
  var layout = React.useMemo(function () {
    return {
      TAG: /* GridLayout */1,
      _0: getAnyLayoutAsGrid(undefined, category)
    };
  }, [category.lastModifiedAt]);
  var category$1 = React.useMemo(function () {
    return Belt_Option.map(Belt_Option.keep(Belt_Option.map(category, function (category) {
      return Category$Showside.setChildren(category, Belt_Array.keep(Category$Showside.getChildren(category), function (category) {
        if (category.visibleInParent) {
          return category.visibleInHeaderSlider;
        } else {
          return false;
        }
      }));
    }), function (category) {
      return Category$Showside.getChildren(category).length !== 0;
    }), function (__x) {
      return Category$Showside.setTabbedSubCategories(__x, undefined);
    });
  }, [category.lastModifiedAt, Belt_Array.map(Category$Showside.getChildren(category), function (child) {
    return child.id;
  })]);
  return Belt_Option.mapWithDefault(category$1, null, function (category) {
    var tmp;
    if (category.showTitle) {
      var tmp$1 = {
        path: path,
        layout: layout
      };
      if (link !== undefined) {
        tmp$1.link = Caml_option.valFromOption(link);
      }
      tmp = React.createElement(NavMenu__Breadcrumbs$Showside.make, tmp$1);
    } else {
      tmp = null;
    }
    return React.createElement(SectionContent$Showside.make, {
      index: 0,
      preferredContentType: /* Category */1,
      category: category,
      layout: layout,
      scrollableContainerRef: scrollableContainerRef,
      forcedOpenLink: getForcedOpenLink,
      enableFirstCard: false,
      customTitle: tmp
    });
  });
}
NavMenu__Sections$CLPQuickCategoriesSection.displayName = "NavMenu__Sections.CLPQuickCategoriesSection";
var make$1 = React.memo(NavMenu__Sections$CLPQuickCategoriesSection);
var CLPQuickCategoriesSection = {
  make: make$1
};
function NavMenu__Sections(Props) {
  var allowQuickCategoriesOpt = Props.allowQuickCategories;
  var allCategories = Props.allCategories;
  var category = Props.category;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var allowQuickCategories = allowQuickCategoriesOpt !== undefined ? allowQuickCategoriesOpt : true;
  var path = React.useMemo(function () {
    return Category$Showside.getCategoryPathById(allCategories, category.id);
  }, [allCategories, category.id]);
  var link = NavMenu__Link$Showside.useLinkFromCategory(undefined, category);
  var ctx = NavMenu__Context$Showside.use(undefined);
  var getForcedOpenLink = React.useCallback(function (category) {
    var categoryPath = Category$Showside.getCategoryPathById(allCategories, category.id);
    if (categoryPath.length > ctx.maxLevels) {
      return /* ForceAllCards */0;
    } else {
      return /* ForceLastCards */2;
    }
  }, [allCategories]);
  var isDeadend = Category$Showside.getChildren(category).length === 0;
  return React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col pt-8 space-y-row-custom")
  }, isDeadend ? React.createElement(NavMenu__PLPContent$Showside.make, {
    category: category,
    path: path,
    link: link,
    scrollableContainerRef: scrollableContainerRef,
    getForcedOpenLink: getForcedOpenLink
  }) : React.createElement(React.Fragment, undefined, allowQuickCategories ? React.createElement(make$1, {
    category: category,
    path: path,
    link: link,
    scrollableContainerRef: scrollableContainerRef,
    getForcedOpenLink: getForcedOpenLink
  }) : null, Belt_Array.mapWithIndex(Belt_Array.keep(Category$Showside.getChildren(category), function (category) {
    return category.visibleInSectionList;
  }), function (index, category) {
    return React.createElement(make, {
      index: index + 1 | 0,
      category: category,
      scrollableContainerRef: scrollableContainerRef,
      getForcedOpenLink: getForcedOpenLink,
      key: category.id
    });
  })));
}
NavMenu__Sections.displayName = "NavMenu__Sections";
var make$2 = React.memo(NavMenu__Sections);
export { getAnyLayoutAsGrid, CLPSection, CLPQuickCategoriesSection, make$2 as make };
/* make Not a pure module */